import { render, staticRenderFns } from "./activityEditV2.vue?vue&type=template&id=19cbae36&"
import script from "./activityEditV2.vue?vue&type=script&lang=js&"
export * from "./activityEditV2.vue?vue&type=script&lang=js&"
import style0 from "./activityEditV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports